<div class="flex align-c justify-c height-100 width-100 pos-a loader-bg"
  style="top: 0px;bottom: 0px;left: 0px;right: 0px;;z-index: 1;">
  <div class="flex align-c justify-c height-100 width-100">
    <div class="{{className}}" [style.width]="size+'px'" [style.height]="size+'px'"></div>
  </div>
</div>
